<div class="progress text-center">
    <div
        [class.bg-success]="value() >= 75"
        [class.bg-primary]="value() >= 50 && value() < 75"
        [class.bg-warning]="value() >= 25 && value() < 50"
        [class.bg-danger]="value() < 25"
        role="progressbar"
        [style.width]="value() + '%'"
        aria-valuemin="0"
        aria-valuemax="100"
    >
        {{ value() }}%
    </div>
</div>
